import { getAuth } from "firebase/auth";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { useAuthState } from "react-firebase-hooks/auth";
import Login from "../components/account/login";
import Register from "../components/account/register";
import Manage from "../components/account/manage";
import { useEffect, useState } from "react";
import PasswordReset from "../components/account/passwordReset";
import { Link } from "react-router-dom";
import LoadingAlert from "../components/common/loadingAlert";

const auth = getAuth();

export default function Account() {
	const [user, userLoading, userError] = useAuthState(auth);

	const [currentTab, setCurrentTab] = useState("login");

	const [passwordResetMode, setPasswordResetMode] = useState(false);

	useEffect(() => {
		if (currentTab !== "login") return;
		setPasswordResetMode(false);
	}, [currentTab]);

	if (userLoading || userError) {
		return <LoadingAlert error={userError} />;
	}

	return (
		<div>
			{!user ? (
				<Tabs
					variant="underline"
					className="mb-2"
					justify
					activeKey={currentTab}
					onSelect={(tab) => setCurrentTab(tab!)}>
					<Tab eventKey="login" title="Anmelden">
						{passwordResetMode ? (
							<PasswordReset changeMode={() => setPasswordResetMode(false)} />
						) : (
							<Login changeMode={() => setPasswordResetMode(true)} />
						)}
					</Tab>
					<Tab eventKey="register" title="Registrieren">
						<Register />
					</Tab>
				</Tabs>
			) : (
				<Manage />
			)}

			<div className="float-end">
				<Link className="text-secondary" to="/privacy">
					Datenschutz
				</Link>
				<span className="text-secondary"> | </span>
				<Link className="text-secondary" to="/imprint">
					Impressum
				</Link>
			</div>
		</div>
	);
}
